import React from "react";
import OrderTable from "./components/OrderTable";
import { useOrderFilters } from "./hooks/useOrderFilters";
import styled from "styled-components";

const PAGE_ID = 117;

const OrderPage = styled.div`
  width: 100%;
  min-height: 100%;
`;

interface OrderListCtrlProps {
  query?: any;
  [key: string]: any;
}

export default function OrderListCtrl(props: OrderListCtrlProps) {
  const { buildQueryParams, updatePagination } = useOrderFilters();

  return (
    <OrderPage>
      <OrderTable
        pageId={PAGE_ID}
        title={props?.query?.name}
        query={props?.query}
        buildQueryParams={buildQueryParams}
        updatePagination={updatePagination}
      />
    </OrderPage>
  );
}
